/**
 * @fileoverview POST handler for the "/engagement/email_templates/duplicate" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementEmailTemplatesDuplicateCacheKeys } from "./constants";
import type { PostEngagementEmailTemplatesDuplicateProps, EngagementEmailTemplatesDuplicateResult } from "./types";

export const postEngagementEmailTemplatesDuplicate = reactQueryMutationAdapter(
  engagementEmailTemplatesDuplicateCacheKeys,
  (props: PostEngagementEmailTemplatesDuplicateProps): Promise<EngagementEmailTemplatesDuplicateResult> => {
    return fetch("/engagement/email_templates/duplicate", "POST", props);
  }
);
